export default __webpack_public_path__ + "static/media/clock.eed44f88.png";